$('body').on('click', '.add-slide-trigger', function() {
    var $this = $(this);
    var action = $('.add-slide form').attr('data-action').replace('{story}', $this.attr('data-story'));
    $('.add-slide form').attr('action', action);
    $('.add-slide [name="publish_date"]').val(new Date().toDateTimeString());
    openModal('.add-slide');
    return false;
});


var slideLinkItem = `<div class="link-item item">
    <a href="" class="remove-link-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
    <a href="" class="add-link-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

    <ul class="fields no-padding">
        <li class="half">
            <input type="text" name="link[]" class="required">
            <span>Link</span>
        </li>

        <li class="half last">
            <input type="text" name="label[]" class="required">
            <span>Label</span>
        </li>
    </ul>
</div>`;

$('body').on('click', '.add-slide .add-link-item-trigger, .edit-slide .add-link-item-trigger', function () {
    var $this = $(this);
    var modal = $this.parents('.add-slide, .edit-slide');
    modal.find('.setup-link-items').append(slideLinkItem);
    return false;
});

$('body').on('click', '.add-slide .add-link-item-trigger-before, .edit-slide .add-link-item-trigger-before', function () {
    var $this = $(this);
    // var modal = $this.parents('.add-slide, .edit-slide');
    $this.parents('.link-item').before(slideLinkItem);
    return false;
});

$('body').on('click', '.add-slide .remove-link-item-trigger, .edit-slide .remove-link-item-trigger', function () {
    var $this = $(this);
    $this.parents('.link-item').remove();
    return false;
});

$('body').on('keydown', '.add-slide input[name="label[]"], .edit-slide input[name="label[]"]', function (e) {
    if (e.keyCode === 9) {
        var $this = $(this);
        if ($this.parents('.link-item').is(':last-child')) {
            e.preventDefault();
            var modal = $this.parents('.add-slide, .edit-slide');
            modal.find('.add-link-item-trigger').trigger('click');
            $this.parents('.link-item').next().find('input[type="text"]').focus();
        }
    }
});


$("body").on("click", ".open-slide-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".slide-menu-wrapper");

    $(".slide-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".slide-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".slide-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-slide-trigger', function() {
    var data = $(this).parents('.slide');
    var action = $('.edit-slide form').attr('data-action').replace('{slide}', data.attr('data-slide'));
    $('.edit-slide form').attr('action', action);

    $('.edit-slide [name="title"]').val(data.attr('data-title'));
    $('.edit-slide [name="duration"]').val(data.attr('data-duration'));
    $('.edit-slide [name="publish_date"]').val(data.attr('data-publish_date'));

    fileUploaderRemoveFile($('.edit-slide .file-uploader[data-file="asset"]'));
    if (data.attr('data-asset')) {
        fileUploaderAddFile($('.edit-slide .file-uploader[data-file="asset"]'), data.attr('data-asset_name'), data.attr('data-asset'));
    }

    fileUploaderRemoveFile($('.edit-slide .file-uploader[data-file="source_asset"]'));
    if (data.attr('data-source_asset')) {
        fileUploaderAddFile($('.edit-slide .file-uploader[data-file="source_asset"]'), data.attr('data-source_asset_name'), data.attr('data-source_asset'));
    }
    $('.edit-slide [name="source_link"]').val(data.attr('data-source_link'));

    $('.edit-slide [name="description"]').val(data.attr('data-description'));
    $('.edit-slide [name="published"]').prop('checked', data.attr('data-published') ? true : false);
    $('.edit-slide [name="template"][value="'+data.attr('data-template')+'"]').prop('checked', true);
    
    var linkItems = JSON.parse(data.attr('data-links'));
    $('.edit-slide .setup-link-items').html('');
    $.each(linkItems, function (index, linkItem) {
        $('.setup-link-items').append(`<div class="link-item item">
            <a href="" class="remove-link-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
            <a href="" class="add-link-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

            <ul class="fields no-padding">
                <li class="half filled">
                    <input type="text" name="link[]" class="required" value="${linkItem.link}">
                    <span>Link</span>
                </li>

                <li class="half filled last">
                    <input type="text" name="label[]" class="required" value="${linkItem.label}">
                    <span>Label</span>
                </li>
            </ul>
        </div>`);
    });

    openModal('.edit-slide');
    closeDropdown();
    return false;
});

$('body').on('click', '.duplicate-slide-trigger', function () {
    var data = $(this).parents('.slide');
    var action = $('.add-slide form').attr('data-action').replace('{story}', data.attr('data-story'));
    $('.add-slide form').attr('action', action);

    $('.add-slide [name="title"]').val(data.attr('data-title'));
    $('.add-slide [name="duration"]').val(data.attr('data-duration'));
    $('.add-slide [name="publish_date"]').val(data.attr('data-publish_date'));

    fileUploaderRemoveFile($('.add-slide .file-uploader[data-file="asset"]'));
    if (data.attr('data-asset')) {
        fileUploaderAddFile($('.add-slide .file-uploader[data-file="asset"]'), data.attr('data-asset_name'), data.attr('data-asset'));
    }

    fileUploaderRemoveFile($('.add-slide .file-uploader[data-file="source_asset"]'));
    if (data.attr('data-source_asset')) {
        fileUploaderAddFile($('.add-slide .file-uploader[data-file="source_asset"]'), data.attr('data-source_asset_name'), data.attr('data-source_asset'));
    }
    $('.add-slide [name="source_link"]').val(data.attr('data-source_link'));

    $('.add-slide [name="description"]').val(data.attr('data-description'));
    $('.add-slide [name="published"]').prop('checked', data.attr('data-published') ? true : false);
    $('.add-slide [name="template"][value="' + data.attr('data-template') + '"]').prop('checked', true);

    var linkItems = JSON.parse(data.attr('data-links'));
    $('.add-slide .setup-link-items').html('');
    $.each(linkItems, function (index, linkItem) {
        $('.setup-link-items').append(`<div class="link-item item">
            <a href="" class="remove-link-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
            <a href="" class="add-link-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

            <ul class="fields no-padding">
                <li class="half filled">
                    <input type="text" name="link[]" class="required" value="${linkItem.link}">
                    <span>Link</span>
                </li>

                <li class="half filled last">
                    <input type="text" name="label[]" class="required" value="${linkItem.label}">
                    <span>Label</span>
                </li>
            </ul>
        </div>`);
    });

    openModal('.add-slide');
    closeDropdown();
    return false;
});

$('body').on('submit', '.add-slide form, .edit-slide form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!modal.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-slide', function(data) {
    // console.log(data);
    var element;

    if($('.slide[data-slide="'+data.slide+'"]').length) {
        element = $('.slide[data-slide="'+data.slide+'"]');

        element.attr('data-story', data.story);
        element.attr('data-asset', data.asset);
        element.attr('data-asset_name', data.asset_name);
        element.attr('data-asset_file_name', data.asset_file_name);
        element.attr('data-asset_url', data.asset_url);
        element.attr('data-asset_type', data.asset_type);

        element.attr('data-source_asset', data.source_asset);
        element.attr('data-source_asset_name', data.source_asset_name);
        element.attr('data-source_asset_file_name', data.source_asset_file_name);
        element.attr('data-source_asset_url', data.source_asset_url);
        element.attr('data-source_link', data.source_link);

        element.attr('data-template', data.template);
        element.attr('data-duration', data.duration);
        element.attr('data-title', data.title);
        element.attr('data-slug', data.slug);
        element.attr('data-description', data.description);
        element.attr('data-links', JSON.stringify(data.links));
        element.attr('data-published', data.published);
        element.attr('data-publish_date', data.publish_date);

        element.find('[data-input="title"]').html(data.title);
        element.find('[data-input="slug"]').html(data.slug);
        element.find('[data-input="template"]').html(data.template);
        element.find('[data-input="asset_type"]').html(data.asset_type);
        element.find('[data-input="duration"]').html(data.duration);
        element.find('[data-input="short_url"]').html(data.short_url);
        element.find('[data-input="links_count"]').html(data.links_count);
        element.find('[data-input="publish_date_parsed"]').html(data.publish_date_parsed);

        element.find('[data-input="status"]').html(data.status);
        element.find('[data-input="status"]').attr('data-color', data.status_color);

        element.find('.menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'slide',
            'data-story': data.story,
            'data-asset': data.asset,
            'data-asset_name': data.asset_name,
            'data-asset_file_name': data.asset_file_name,
            'data-asset_url': data.asset_url,
            'data-asset_type': data.asset_type,
            'data-source_asset': data.source_asset,
            'data-source_asset_name': data.source_asset_name,
            'data-source_asset_file_name': data.source_asset_file_name,
            'data-source_asset_url': data.source_asset_url,
            'data-source_link': data.source_link,
            'data-template': data.template,
            'data-duration': data.duration,
            'data-title': data.title,
            'data-slug': data.slug,
            'data-description': data.description,
            'data-links': JSON.stringify(data.links),
            'data-published': data.published,
            'data-publish_date': data.publish_date
        });

        element.append(`<td>
            <p data-input="title">${data.title}</p>
            <p class="small-text" data-input="slug">${data.slug}</p>
        </td>
        
        <td>
            <p data-input="template">${data.template}</p>
            <p class="small-text">
                <span data-input="asset_type">${data.asset_type}</span>
                <span data-input="duration">${data.duration}</span>
            </p>
        </td>

        <td data-input="short_url">${data.short_url}</td>

        <td data-input="links_count">${data.links_count}</td>
        
        <td><span class="highlight" data-color="${data.status_color}" data-input="status">${data.status}</span></td>

        <td data-input="publish_date_parsed">${data.publish_date_parsed}</td>
        <td class="slide-menu-wrapper menu-wrapper" data-dropdown="slide-${data.slide}">
            <a href="" class="icon-more open-slide-menu open-menu"></a>
            <ul class="slide-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.slides tbody').prepend(element);
    }
});